import Form from "./Form/form";

function App() {
  return <Form />;
}

export default App;
